import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

export const memberApi = {
  get: (path, params) => axios.get(`${API}/member${path}`, { params, headers: auth() }).then(r => r.data),
  put: (path, body) => axios.put(`${API}/member${path}`, body, { headers: auth() }).then(r => r.data),
  post: (path, body) => axios.post(`${API}/member${path}`, body, { headers: auth() }).then(r => r.data),
  patch: (path, body) => axios.patch(`${API}/member${path}`, body, { headers: auth() }).then(r => r.data),
  del: (path) => axios.delete(`${API}/member${path}`, { headers: auth() }).then(r => r.data),
  photoBlob: () => axios.get(`${API}/member/profile/photo`, { headers: auth(), responseType: "blob" }).then(r => r.data),
};

export const socialApi = {
  get: (path, params) => axios.get(`${API}/social${path}`, { params, headers: auth() }).then(r => r.data),
  put: (path, body) => axios.put(`${API}/social${path}`, body, { headers: auth() }).then(r => r.data),
  post: (path, body) => axios.post(`${API}/social${path}`, body, { headers: auth() }).then(r => r.data),
  del: (path) => axios.delete(`${API}/social${path}`, { headers: auth() }).then(r => r.data),
  patch: (path, body) => axios.patch(`${API}/social${path}`, body, { headers: auth() }).then(r => r.data),
  blob: (path) => axios.get(`${API}/social${path}`, { headers: auth(), responseType: "blob" }).then(r => r.data),
};

export const errorText = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (d?.message) return d.message;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg.replace(/^Value error, /, "");
  return fallback;
};

export const isMembershipDenied = (e) => e?.response?.status === 403;

export const THEMES = [
  { id: "classic", label: "Classic", thumb: null, swatch: "#ffffff" },
  { id: "paper", label: "Ivory", thumb: null, swatch: "#f8f4ea" },
  { id: "sky", label: "Painted Sky", thumb: "/images/themes/painted-sky-thumb.webp" },
  { id: "navy", label: "Navy", thumb: null, swatch: "#0f1d2f" },
  ...[["red-gingham", "Red Gingham"], ["pink-toile", "Pink Toile"], ["pigs", "Piglets"], ["blue-gingham", "Blue Gingham"],
    ["blue-sprigs", "Blue Sprigs"], ["rose-sprigs", "Rose Sprigs"], ["candy-cane", "Candy Cane"], ["cranberry-plaid", "Cranberry Plaid"],
    ["holstein-cows", "Holstein Cows"], ["cowboy-lasso", "Cowboy Lasso"], ["apple-gingham", "Apple Gingham"]]
    .map(([id, label]) => id === "apple-gingham"
      ? { id, label, wallpaper: "/images/wallpapers/apple-gingham-v3.svg", thumb: "/images/wallpapers/apple-gingham-v3.svg" }
      : { id, label, wallpaper: `/images/wallpapers/${id}.jpg`, thumb: `/images/wallpapers/${id}-thumb.webp` }),
];
export const WALLPAPER = Object.fromEntries(THEMES.filter(t => t.wallpaper).map(t => [t.id, t.wallpaper]));

const adminAuth = () => ({ Authorization: `Bearer ${localStorage.getItem("adminToken")}` });
export const adminApi = {
  get: (path, params) => axios.get(`${API}/admin/farmstand${path}`, { params, headers: adminAuth() }).then(r => r.data),
  post: (path, body) => axios.post(`${API}/admin/farmstand${path}`, body, { headers: adminAuth() }).then(r => r.data),
  put: (path, body) => axios.put(`${API}/admin/farmstand${path}`, body, { headers: adminAuth() }).then(r => r.data),
  del: (path) => axios.delete(`${API}/admin/farmstand${path}`, { headers: adminAuth() }).then(r => r.data),
};

export const problemsText = (e) => {
  const d = e?.response?.data?.detail;
  if (d?.problems) return `${d.message}: ${d.problems.join("; ")}`;
  return errorText(e);
};
